"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSelectors = void 0;
function generateSelectors({ store, selectors, }) {
    const selectorsState = {};
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const selector in selectors) {
        selectorsState[selector] = selectors[selector](store);
    }
    return selectorsState;
}
exports.generateSelectors = generateSelectors;
//# sourceMappingURL=generate-selectors.js.map